import { useTheme } from "@mui/material";
import { AnimatedBorder } from "@surfaces/auth/components/AnimatedBorder/AnimatedBorder";
import Logo from "@ui/atoms/Logo/Logo";
import {
  AuthFormCard,
  AuthFormContainer,
  AuthLogoLink
} from "@ui/molecules/FormsComponents/FormsComponents";

import MfaSetupForm from "./MfaSetupForm";

// Forced TOTP enrolment presented in the standard auth card shell (gradient
// background, bounded card, logo) so it looks identical whether it appears in
// the login flow or mid-session over the app. Without this shell the mid-session
// render was unbounded/full-bleed.
const MfaSetupScreen = () => {
  const theme = useTheme();
  return (
    <AuthFormContainer>
      <AuthFormCard spacing={2}>
        <AnimatedBorder />
        <AuthLogoLink href="/">
          <Logo
            variant="mark"
            width={40}
            startColor={theme.vars.ui.logo.gradient.from}
            endColor={theme.vars.ui.logo.gradient.to}
          />
        </AuthLogoLink>
        <MfaSetupForm />
      </AuthFormCard>
    </AuthFormContainer>
  );
};

export default MfaSetupScreen;
